import { Button, Modal, ModalBackdrop, ModalBody, ModalContent, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StyleSheet } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { theme } from '../../theme'

const BORDER_RADIUS = 15
const MIN_HEIGHT = 300
const LINE_DOWN_WIDTH = 50
const LINE_DOWN__HEIGHT = 5
const LINE_VIEW_HEIGHT = 10

export interface DaySchedulesProps {
  title?: string
  content?: string
  fullscreen?: boolean
  show: boolean
  onClose: () => void
  children?: React.ReactNode
}

export const ModalBottom: FunctionComponent<DaySchedulesProps> = ({ title, content, fullscreen, show, onClose, children }) => {
  const insets = useSafeAreaInsets()

  return (
    <Modal isOpen={show} onClose={onClose}>
      <ModalBackdrop />
      <ModalContent style={[styles.modalContent, fullscreen ? styles.fullscreenModal : styles.bottomModal]}>
        <ModalBody style={styles.modalBody}>
          <View style={[fullscreen ? styles.safeView : styles.safeViewMinHeight, { paddingTop: fullscreen ? insets.top : 0 }]}>
            {!fullscreen && (
              <View style={styles.emptyCollapse}>
                <View style={styles.emptyCollapseLine} />
              </View>
            )}
            <View style={[styles.content, fullscreen ? styles.fullscreen : {}, { paddingBottom: insets.bottom }]}>
              {title !== undefined && <Text style={styles.title}>{title}</Text>}
              {content !== undefined && <Text>{content}</Text>}
              {children}
              {fullscreen && (
                <Button variant="link" style={styles.closeButton} onPress={onClose}>
                  <Ionicons name="close-outline" size={24} />
                </Button>
              )}
            </View>
          </View>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modalContent: {
    backgroundColor: theme.colors.transparent,
    shadowColor: 'transparent',
    elevation: 0,
  },
  modalBody: {
    padding: 0,
  },
  bottomModal: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    maxHeight: '90%',
  },
  fullscreenModal: {
    flex: 1,
    width: '100%',
    maxHeight: '100%',
  },
  safeView: {
    flex: 1,
    width: '100%',
    backgroundColor: theme.colors.white,
  },
  safeViewMinHeight: {
    backgroundColor: theme.colors.transparent,
    minHeight: MIN_HEIGHT,
  },
  fullscreen: {
    flex: 1,
  },
  closeButton: {
    position: 'absolute',
    right: 0,
  },
  modal: {
    width: '100%',
  },
  emptyCollapse: {
    width: '100%',
    height: LINE_VIEW_HEIGHT,
    alignItems: 'center',
  },
  emptyCollapseLine: {
    height: LINE_DOWN__HEIGHT,
    width: LINE_DOWN_WIDTH,
    backgroundColor: theme.colors.white,
    borderRadius: BORDER_RADIUS,
  },
  content: {
    minHeight: MIN_HEIGHT,
    paddingHorizontal: theme.padding.x2,
    backgroundColor: theme.colors.white,
    borderTopLeftRadius: BORDER_RADIUS,
    borderTopRightRadius: BORDER_RADIUS,
  },
  title: {
    width: '100%',
    textAlign: 'center',
    marginTop: theme.padding.x1,
    paddingBottom: theme.padding.x2,
    fontSize: theme.textSize.x3,
    lineHeight: theme.textSize.x3,
  },
})
